<template>
  <div class="rrd-db-page">
    <!-- STICKY TOP: TITLE -->
    <div class="rrd-sticky-top">
      <div class="rrd-sticky-head-row px-2 mb-2">
        <div class="rrd-head-slot rrd-head-slot--left" aria-hidden="true"></div>
        <h3 class="rrd-title m-0 rrd-head-title">Staff Login</h3>
        <div class="rrd-head-slot rrd-head-slot--right" aria-hidden="true"></div>
      </div>
    </div>

    <!-- CONTENT -->
    <div class="flex-grow-1 d-flex rrd-auth-wrap">
      <div class="rrd-auth-card">
        <template v-if="step === 'login'">
          <b-form @submit.prevent="submitLogin">
            <b-form-group class="mb-3">
              <label class="rrd-label">Email</label>
              <b-form-input
                v-model.trim="username"
                :state="usernameState"
                type="text"
                placeholder="Enter email"
                class="rrd-input"
              />
              <b-form-invalid-feedback id="inputUsernameFeedback">
                Field is mandatory
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group class="mb-4">
              <label class="rrd-label">Password</label>
              <b-form-input
                v-model="password"
                :state="passwordState"
                type="password"
                placeholder="Enter password"
                class="rrd-input"
              />
              <b-form-invalid-feedback id="inputPasswordFeedback">
                Field is mandatory
              </b-form-invalid-feedback>
            </b-form-group>

            <b-button
              type="submit"
              block
              class="rrd-btn-primary text-uppercase"
            >
              Login
            </b-button>

<!--            <div class="mt-3 text-center">
              <a href="#" class="rrd-link">Forgot Password?</a>
            </div>-->
          </b-form>
        </template>

        <TwoFactorForm v-else-if="step === '2fa'" :user-id="id" />
      </div>
    </div>

    <loading :show="show" :label="label" :overlay="overlay" />
  </div>
</template>

<script>
import routeName from '@/router/routeNames'
import loading from 'vue-full-loading'
import { required, minLength } from 'vuelidate/lib/validators'
import { toast } from '@/shared/plugins/toastr'
import { INSTITUTION_USER, INSTITUTION_VIEW_USER } from '@/shared/constants'
import TwoFactorForm from '@/components/auth/TwoFactorForm.vue'

export default {
  name: 'Login',
  components: { TwoFactorForm, loading },
  data() {
    return {
      username: '',
      password: '',
      usernameState: null,
      passwordState: null,
      show: false,
      label: 'Logging in...',
      overlay: true,
      error: '',
      step: 'login',
      id: null,
    }
  },
  computed: {
    errorMessage() {
      return this.error
    },
  },
  validations: {
    username: { required, minLength: minLength(2) },
    password: { required, minLength: minLength(2) },
  },
  methods: {
    submitLogin() {
      localStorage.clear()

      // reset state prije validacije
      this.usernameState = null
      this.passwordState = null

      if (this.$v.username.$invalid) this.usernameState = false
      if (this.$v.password.$invalid) this.passwordState = false
      if (this.$v.$invalid) return

      this.show = true

      this.$store
        .dispatch('auth/actionLogin', { username: this.username, password: this.password })
        .then((response) => {
          if (response.data.status === '2fa_required') {
            this.step = '2fa'
            this.show = false
            this.id = response.data.id
            return
          }

          this.$store.dispatch('user/actionSetUser').then((userResponse) => {
            if (userResponse.role.id === INSTITUTION_USER || userResponse.role.id === INSTITUTION_VIEW_USER) {
              this.$store.dispatch('institution/actionSetInstitution', userResponse.institution.id)
            }

            this.$store
              .dispatch('user/actionSetUserPermissions')
              .then(() => {
                toast({ title: 'Login successful', type: 'success' })
              })
              .finally(() => {
                this.$router.replace({ name: routeName.RN_DASHBOARD })
                this.show = false
              })
          })
        })
        .catch(() => {
          this.step = 'login'
          this.show = false
          toast({
            title: 'Login failed',
            message: 'Provide the correct username and password',
            type: 'error',
          })
        })
    },
  },
  beforeRouteEnter(to, from, next) {
    document.body.classList.add('page-login')
    next()
  },
}
</script>

